/* eslint-disable @typescript-eslint/ban-ts-comment */
import {get as getCookies} from 'es-cookie'
import {createClient} from 'graphql-ws'
import {GraphQLWsLink} from '@apollo/client/link/subscriptions'
import {createUploadLink} from 'apollo-upload-client'
import {split} from '@apollo/client'
import {getMainDefinition} from '@apollo/client/utilities'

import {APP_NAME, IS_TEST, TAB_UUID} from '@sdox/utils/dom'

import type {ApolloLink} from '@apollo/client'

const createWsLink = () => {
  const wsLink = new GraphQLWsLink(createClient({
    url: `${window.location.protocol === 'http:' ? 'ws' : 'wss'}://${window.location.host}/graphqlws/`,
    connectionParams: () => {
      return {
        csrfToken: getCookies('csrftoken') ?? undefined,
        tabUuid: TAB_UUID,
        href: window.location.href,
        appName: APP_NAME,
      }
    },
    keepAlive: 10 * 1000,
    retryAttempts: Infinity,
    // We can retry infinite because we retry regardless of the response code
    // This means in the worst case we will try to reconnect each hour (even with an fatal code)
    shouldRetry: () => true,
    retryWait: async (retries) => {
      const timeToWait = retries > 12 ? 3600 : 2 ** retries // max 1h; avoid integer overflow
      console.log(`[Websocket] RetryWait ${timeToWait}`)
      await new Promise((r) => setTimeout(r, timeToWait * 1000))
    },
  }))
  return wsLink
}

export const createApolloLink = () => {
  const httpLink = createUploadLink({uri: `${window.location.protocol}//${window.location.host}/graphql/`}) as unknown as ApolloLink
  // node environment, e.g. test: we do not have access to websockets and the tests will fail
  // We split the createWsLink into a own function to be treeshaked >:)
  if (IS_TEST) return httpLink
  const wsLink = createWsLink()

  return split(
    ({query}) => {
      const mainDefinition = getMainDefinition(query)
      const isSubscription =
          mainDefinition.kind === 'OperationDefinition' &&
          mainDefinition.operation === 'subscription'
      return isSubscription
    },
    wsLink,
    httpLink,
  )
}
